// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img.displayed-slider-image {
  width: 100%;
}
@media (max-width: 575.98px) {
  img.displayed-slider-image {
    min-height: 370px;
    object-fit: cover;
  }
}
@media (min-width: 576px) and (max-width: 1599.98px) {
  img.displayed-slider-image {
    min-height: 500px;
    object-fit: cover;
  }
}
@media (min-width: 1400px) and (max-width: 1599.98px) {
  img.displayed-slider-image {
    min-height: 570px;
    object-fit: cover;
  }
}
@media (min-width: 1600px) {
  img.displayed-slider-image {
    min-height: 660px;
    height: auto;
  }
}
@media (min-width: 1800px) {
  img.displayed-slider-image {
    min-height: 680px;
    height: auto;
  }
}

.image-upload > input {
  display: none;
}

.slider-image-input-icon,
.slider-image-delete-icon,
.slider-image-upload-icon {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  border: solid 1px transparent;
  margin-bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.3s;
}
.slider-image-input-icon .la-pencil-alt-icon:before,
.slider-image-delete-icon .la-pencil-alt-icon:before,
.slider-image-upload-icon .la-pencil-alt-icon:before {
  font-size: 25px;
  color: #fff;
}
.slider-image-input-icon .la-delete-icon:before,
.slider-image-delete-icon .la-delete-icon:before,
.slider-image-upload-icon .la-delete-icon:before {
  font-size: 22px;
  color: #fff;
  margin-right: -2px;
}
.slider-image-input-icon .la-upload-icon:before,
.slider-image-delete-icon .la-upload-icon:before,
.slider-image-upload-icon .la-upload-icon:before {
  font-size: 22px;
  color: #fff;
  margin-right: -2px;
}

.slider-image-input-icon {
  background: #5c6bc0;
}
.slider-image-input-icon:hover, .slider-image-input-icon:focus {
  background: #283593;
}

.slider-image-delete-icon {
  background: #ef5350;
}
.slider-image-delete-icon:hover, .slider-image-delete-icon:focus {
  background: #c62828;
}

.slider-image-upload-icon {
  background: #388e3c;
}
.slider-image-upload-icon:hover, .slider-image-upload-icon:focus {
  background: #1b5e20;
}

.admin-slider-image-card-container {
  overflow-x: auto;
  display: flex;
}

.slider-image-card {
  max-width: 300px;
  border-bottom: 10px solid #fff;
  object-fit: contain;
  border-radius: 4px;
  margin: 0 0.5rem;
  transition: 0.4s;
}

.slider-image-card.active {
  border-bottom: 10px solid crimson;
  transform: translateY(-10px) scale(1.02);
  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/adminPages/home/carousel.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AACE;EAHF;IAII,iBAAA;IACA,iBAAA;EAEF;AACF;AAAE;EARF;IASI,iBAAA;IACA,iBAAA;EAGF;AACF;AADE;EAbF;IAcI,iBAAA;IACA,iBAAA;EAIF;AACF;AAFE;EAlBF;IAmBI,iBAAA;IACA,YAAA;EAKF;AACF;AAHE;EAvBF;IAwBI,iBAAA;IACA,YAAA;EAMF;AACF;;AAHA;EACE,aAAA;AAMF;;AAHA;;;EAGE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAMF;AAJE;;;EACE,eAAA;EACA,WAAA;AAQJ;AALE;;;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AASJ;AANE;;;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AAUJ;;AANA;EACE,mBAAA;AASF;AARE;EAEE,mBAAA;AASJ;;AALA;EACE,mBAAA;AAQF;AAPE;EAEE,mBAAA;AAQJ;;AAJA;EACE,mBAAA;AAOF;AANE;EAEE,mBAAA;AAOJ;;AAHA;EACE,gBAAA;EACA,aAAA;AAMF;;AAHA;EACE,gBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAMF;;AAHA;EACE,iCAAA;EACA,wCAAA;EACA,4EAAA;AAMF","sourcesContent":["img.displayed-slider-image {\r\n  width: 100%;\r\n\r\n  @media (max-width: 575.98px) {\r\n    min-height: 370px;\r\n    object-fit: cover;\r\n  }\r\n\r\n  @media (min-width: 576px) and (max-width: 1599.98px) {\r\n    min-height: 500px;\r\n    object-fit: cover;\r\n  }\r\n\r\n  @media (min-width: 1400px) and (max-width: 1599.98px) {\r\n    min-height: 570px;\r\n    object-fit: cover;\r\n  }\r\n\r\n  @media (min-width: 1600px) {\r\n    min-height: 660px;\r\n    height: auto;\r\n  }\r\n\r\n  @media (min-width: 1800px) {\r\n    min-height: 680px;\r\n    height: auto;\r\n  }\r\n}\r\n\r\n.image-upload > input {\r\n  display: none;\r\n}\r\n\r\n.slider-image-input-icon,\r\n.slider-image-delete-icon,\r\n.slider-image-upload-icon {\r\n  height: 50px;\r\n  width: 50px;\r\n  border-radius: 50%;\r\n  border: solid 1px transparent;\r\n  margin-bottom: 0;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  transition: 0.3s;\r\n\r\n  .la-pencil-alt-icon:before {\r\n    font-size: 25px;\r\n    color: #fff;\r\n  }\r\n\r\n  .la-delete-icon:before {\r\n    font-size: 22px;\r\n    color: #fff;\r\n    margin-right: -2px;\r\n  }\r\n\r\n  .la-upload-icon:before {\r\n    font-size: 22px;\r\n    color: #fff;\r\n    margin-right: -2px;\r\n  }\r\n}\r\n\r\n.slider-image-input-icon {\r\n  background: #5c6bc0;\r\n  &:hover,\r\n  &:focus {\r\n    background: #283593;\r\n  }\r\n}\r\n\r\n.slider-image-delete-icon {\r\n  background: #ef5350;\r\n  &:hover,\r\n  &:focus {\r\n    background: #c62828;\r\n  }\r\n}\r\n\r\n.slider-image-upload-icon {\r\n  background: #388e3c;\r\n  &:hover,\r\n  &:focus {\r\n    background: #1b5e20;\r\n  }\r\n}\r\n\r\n.admin-slider-image-card-container{\r\n  overflow-x: auto;\r\n  display: flex;\r\n}\r\n\r\n.slider-image-card{\r\n  max-width: 300px;\r\n  border-bottom: 10px solid #fff;\r\n  object-fit: contain;\r\n  border-radius: 4px;\r\n  margin: 0 .5rem;\r\n  transition: .4s;\r\n}\r\n\r\n.slider-image-card.active{\r\n  border-bottom: 10px solid crimson;\r\n  transform: translateY(-10px) scale(1.02);\r\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 6px, rgba(0, 0, 0, 0.23) 0px 3px 6px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
